import React from 'react';
import type { FC } from 'react';

import { useCardDataContext } from '../../data-provider/context';
import { defaultDividendBannerTexts, dataTestIds } from '../../configs';
import { isDateInFuture } from '../../helpers';

import type { TInvestEmitentsDetailCardDividendBanner } from './models';

export const DividendBannerContainer: FC<TInvestEmitentsDetailCardDividendBanner> = ({
    View,
    analytics,
    anchorLink,
    backgroundColor,
    buttonText,
    className,
    payDateTooltipHint = defaultDividendBannerTexts.cells.payDate.hint,
    paymentType = defaultDividendBannerTexts.paymentType,
    title,
}) => {
    const { card: assets } = useCardDataContext();

    const hasResult = assets.length;
    const asset = hasResult ? assets[0] : null;

    if (!asset || !asset?.isVisible) {
        return null;
    }

    const hasCorrectDividendDate = isDateInFuture(
        asset.typeSpecificPropertiesDto?.dividends?.lastDate
    );

    if (!hasCorrectDividendDate) {
        return null;
    }

    return (
        <section className={className} data-test-id={dataTestIds.dividendBannerContainer}>
            <View
                analytics={analytics}
                anchorLink={anchorLink}
                asset={asset}
                backgroundColor={backgroundColor}
                buttonText={buttonText}
                payDateTooltipHint={payDateTooltipHint}
                paymentType={paymentType}
                title={title}
            />
        </section>
    );
};
